// extracted by css-extract-rspack-plugin
export default {"header":"AgentsView-module__header__kYfAy","description":"AgentsView-module__description__aE0nN","failedTaskBanners":"AgentsView-module__failedTaskBanners__9pbjO"};